<template>
    <LayoutDefault>
        <div
              class="container"
              id="video_index"
        >
            <section class="categories">
                <h3 class="title">
                    {{$t('header.new_videos')}}
                </h3>
                <template v-if="!loadingHotMovies && !errorHotMovies">
                    <template
                            v-if="hotMovies.length !== 0"
                    >
                        <div class="videos">
                            <VideoBox
                                    v-for="hotMovie in hotMovies"
                                    :video="hotMovie"
                                    :key="hotMovie.id"
                            />
                        </div>
                        <div class="videos-footer" v-if="!loadingMoreHotMovies && hotMoviesCurrentPage">
                            <button
                                    type="button"
                                    @click.prevent="loadMoreHotMovies"
                            >
                                {{$t('load_more')}}
                            </button>
                        </div>
                        <Spinner v-if="loadingMoreHotMovies"/>
                    </template>
                    <div
                            class=""
                            v-else
                    >
                        <p>
                            {{$t('noRecords')}}
                        </p>
                    </div>
                </template>
                <template v-else>
                    <Spinner v-if="loadingHotMovies"/>
                    <template v-if="errorHotMovies">
                        <p>
                            {{$t('error')}}
                        </p>
                        <button
                                type="button"
                                @click="loadHotMovies"
                        >
                            {{$t('retry')}}
                        </button>
                    </template>
                </template>
            </section>
        </div>
    </LayoutDefault>
</template>

<script>
    import VideoBox from '../components/VideoBox';
    import Spinner from '../components/Spinner';
    import EventBus from '../eventbus';
    import resources from '../resources';
    import LayoutDefault from "../layouts/LayoutDefault";

    const resultsPerPage = 16;

    export default {
        components: {
            LayoutDefault,
            VideoBox,
            Spinner
        },
        methods: {
            loadHotMovies(){
                this.loadingHotMovies = true;
                this.loadingMoreHotMovies = false;
                this.hotMoviesCurrentPage = null;
                this.hotMovies = null;
                this.errorHotMovies = false;

                resources.movies.index(Object.assign({}, this.filters, {per_page: resultsPerPage, page: 1}))
                    .then((response) => {
                        this.loadingHotMovies = false;
                        this.hotMovies = response.data.data;
                        this.hotMoviesCurrentPage = 1;
                    }).catch(() => {
                        this.loadingHotMovies = false;
                        this.errorHotMovies = true;
                    });
            },
            loadMoreHotMovies(){
                this.loadingMoreHotMovies = true;

                resources.movies.index(Object.assign({}, this.filters, {per_page: resultsPerPage, page: this.hotMoviesCurrentPage + 1}))
                    .then((response) => {
                        this.loadingMoreHotMovies = false;
                        this.hotMovies = this.hotMovies.concat(response.data.data);

                        if(response.data.data.length === resultsPerPage){
                            this.hotMoviesCurrentPage++;
                        }else{
                            this.hotMoviesCurrentPage = null;
                        }
                    }).catch(() => {
                        this.loadingMoreHotMovies = false;
                    });
            },
        },
        data(){
            return {
                filters: {
                    hot: true,
                },
                hotMoviesCurrentPage: null,
                loadingMoreHotMovies: false,
                loadingHotMovies: true,
                errorHotMovies: false,
                hotMovies: null
            }
        },
        mounted(){
            this.loadHotMovies();

            EventBus.$on('languageChanged', () => {
                this.loadHotMovies();
            });
        },
    }
</script>

<style scoped lang="scss">
  @import '../styles/variables';

  #video_index{
    background-color: $pallete_clear_color;
    min-height: 500px;
    padding: 9px;

    .videos{
      display: flex;
      flex-wrap: wrap;
      margin: 0 -5px;

      .video{
        flex-grow: 0;
        margin-bottom: 30px;
        flex-basis: 25%;

        @media(max-width: 900px){
          flex-basis: 50%;
        }

        @media(max-width: 600px){
          flex-basis: 100%;
        }
      }
    }

    .videos-footer {
        margin: 25px 0;
        text-align: center;
        button {
            padding: .5em 1.5em;
            font-size: 1.5em;
        }
    }
  }
</style>
